import React, { Component } from 'react';
import {connect} from 'react-redux';
import {Control, Form, Errors} from 'react-redux-form';
import AuthorizationAction from '../../actions/AuthorizationAction';
import Preloader from '../../components/Preloader';
import ErrorsConstants from '../../constants/ErrorsConstants';

class Login extends Component {

  submitForm(data) {
    this.props.submitLogin(data.email, data.password)
  }

  changeForm() {
    this.props.resetValidation();
  }
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  render() {
    var errors = this.props.errors;
    return <div>
              <Form model="forms.loginForm" hideNativeErrors
                    onSubmit={(data) => this.submitForm(data)}
                    onChange={this.changeForm.bind(this)}
                    className="login-form">
                <div className="form-group">
                  <label htmlFor="email">Email <span className="red">*</span></label>
                  <Control.text model="forms.loginForm.email"
                                className="form-control"
                                id="email"
                                placeholder="Email"
                                validators={{
                                  required: (val) => val && val.length,
                                  email: this.validateEmail
                                }}/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.loginForm.email"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'email cannot be blank',
                        email: 'not a valid email format'
                      }}
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="password">Password <span className="red">*</span></label>
                  <Control.text model="forms.loginForm.password"
                                type="password"
                                className="form-control"
                                id="password"
                                placeholder="Password"
                                validators={{
                                  required: (val) => val && val.length
                                }}/>
                  <div className="error-box">
                    <Errors
                      className="error"
                      model="forms.loginForm.password"
                      show={(field) => field.submitFailed && !field.valid}
                      messages={{
                        required: 'password cannot be blank'
                      }}
                    />
                    {!errors.incorrectEntities.validation ? <div className="error">{errors.incorrectEntities.text}</div> : null}
                  </div>
                </div>
                {/*<button disabled={this.props.isBusy} type="submit" className="btn btn-default">Login</button>*/}
                <div className="busy-box">
                  {this.props.isBusy ? <div className="error"><Preloader /></div> : null}
                </div>
                <button type="submit" className="btn btn-default">Login</button>
                <div className="ml10 inline mt10">or</div>
                <a href="/#/sign" className="btn btn-default ml10">Sign Up</a>
              </Form>
           </div>
  }
}

export default connect(
  state => ({
    isBusy: state.requestStatus,
    errors: state.errors
  }),
  dispatch => ({
    submitLogin: (email, password) => {
      dispatch(AuthorizationAction.authUser(email, password));
    },
    resetValidation: () => {
      dispatch({type: ErrorsConstants.RESET_VALIDATION_STATUS, payload: 'incorrectEntities'});
    }
  })
)(Login);



/** WEBPACK FOOTER **
 ** ./src/components/Login/index.js
 **/